import React from "react";
import { useDisplayCtrlGood } from "../../../data/clearing/ctrlgoods/hooks/useDisplayCtrlGoods";
import { DisplayDrawerContext } from "../../../layout/DisplayDrawerContext";
import {
  CtrlGoodsData,
  CtrlGoodsListData,
} from "../../../data/clearing/ctrlgoods/types";
import { LocalizationContext } from "../../../core/localization/Localization";
import { DisplayCtrlGoodMainAttributes } from "./DisplayCtrlGoodMainAttributes";
import {
  ExpansionPanel,
  ExpansionPanelSummary,
  Typography,
  Grid,IconButton
} from "@material-ui/core";
import { useCtrlGoodsPrinter } from "../../../data/clearing/ctrlgoods/hooks/useCtrlGoodsPrinter";
import { CustomTooltip } from "../../components/common/CustomTooltip";
import DownloadIcon from "@material-ui/icons/CloudDownloadOutlined";

export interface DisplayCtrlGoodsProps {
  id?: string;
}

export const DisplayCtrlGoods: React.FunctionComponent<DisplayCtrlGoodsProps> = ({
  id,
}) => {
  const ctrlGood = useDisplayCtrlGood(id);
  const { getString } = React.useContext(LocalizationContext);
	const [download, fetchState, setfetch] = useCtrlGoodsPrinter(ctrlGood);

  return !ctrlGood ? (
    <>{"loading placeholder"}</>
  ) : (
    <Grid container justify="center" direction="column">
      <ExpansionPanel expanded>
        <ExpansionPanelSummary>
        <Grid container justify="space-between">
            <Grid item>
            <Typography>{getString("tableBasciInfo")}</Typography>
            </Grid>
							<Grid item>
								<CustomTooltip titleKeyword="exportPDFTooltip">
									<IconButton
										color="secondary"
										component="span"
										onClick={download}
										disabled={fetchState.type !== "not-started"}
									>
										<DownloadIcon />
									</IconButton>
								</CustomTooltip>
                { fetchState.type !== "not-started"  ? getString("pleaseWait") : null }
							</Grid>
          </Grid>
        </ExpansionPanelSummary>
        <DisplayCtrlGoodMainAttributes ctrlGood={ctrlGood} />
      </ExpansionPanel>
    </Grid>
  );
};

export const useViewCtrlGood = () => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  return React.useCallback(
    (ctrlGood: CtrlGoodsListData) =>
      showWithDrawer(<DisplayCtrlGoods id={ctrlGood.controlId} />),
    [showWithDrawer]
  );
};
